import { Typography } from '@mui/material';

import { ReactElement } from 'react';

export const NewsletterSubscriptionLine = (): ReactElement => (
  <Typography fontSize={13} color="text.tertiary" fontWeight={500}>
    Receive occasional product updates.
  </Typography>
);
